<template>
  <div class="page">
    <div class="page-hedaer line-bar-bottom">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item to="/household/index">住户数据</el-breadcrumb-item>
        <el-breadcrumb-item>住户详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="page-body">
      <div class="info" v-loading="detailLoading">
        <div class="info-title">住户信息</div>
        <div class="info-body">
          <el-row :gutter="30">
            <el-col :span="8">
              <div class="info-item">住户名称：{{ info.household_name }}</div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">联系电话：{{ info.household_phone }}</div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">所属社区：{{ info.community_name }}</div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">详情地址：{{ info.detailed_address }}</div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">隔离状态：{{ info.isolation_state === 1 ? '隔离' : '不隔离' }}</div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">创建时间：{{ info.create_time }}</div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">联系人：{{ info.second_linkman }}</div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">联系人电话：{{ info.second_linkman_phone }}</div>
            </el-col>
            <el-col :span="8">
              <div class="info-item"></div>
            </el-col>
          </el-row>
        </div>
      </div>

      <el-divider></el-divider>

      <div class="list" v-loading="loading">
        <div class="info-title">绑定设备</div>

        <el-table :data="deviceListData">
          <el-table-column prop="device_type" label="设备类型">
            <template slot-scope="scope">{{scope.row.device_type | FDeviceType}}</template>
          </el-table-column>
          <el-table-column prop="device_imei" label="设备编号"></el-table-column>
          <el-table-column prop="signal_state" label="信号状态">
            <template slot-scope="scope">
              <div
                class="status"
                :class="{'green':scope.row.signal_state === 1}"
              >{{scope.row.signal_state | FDeviceSignal}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="power_level" label="电量">
            <template slot-scope="scope">
              <div
                class="status"
                :class="scope.row.power_level > 1 ? 'green' : 'red'"
              >{{scope.row.power_level | FDeviceElectric}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="bind_time" label="绑定时间"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <a href="javascript: void(0);" class="link active" @click="handleUnbind(scope.row)">解绑</a>
              <el-divider direction="vertical"></el-divider>
              <a
                href="javascript: void(0);"
                class="link active"
                @click="handleToAlarm(scope.row)"
              >查看记录</a>
            </template>
          </el-table-column>

          <template slot="empty">
            <div class="list-null">
              <img src="../../assets/icons/icon_blank.png" alt="暂无数据" />
              <p>
                <em>暂无数据</em>
              </p>
            </div>
          </template>
        </el-table>
      </div>

      <div class="button">
        <el-button
          type="primary"
          size="medium"
          @click="$router.push('/household/edit/' + householdId)"
        >编 辑</el-button>
        <el-button size="medium" @click="$router.go(-1)">返 回</el-button>
        <el-button size="medium" @click="handleRemove">删除住户</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
    ApiHouseholdDetail,
    ApiHouseholdDelete,
    ApiHouseholdUnbind,
} from '@/api/household';

export default {
    name: 'householdDetailPage',
    data() {
        return {
            detailLoading: false,
            loading: false,

            householdId: this.$route.params.id,

            // 用户数据
            info: {},

            // 表格数据
            deviceListData: [],
        };
    },
    created() {},
    mounted() {
        this.handleGetDetail();
    },
    methods: {
        // 获取详情
        handleGetDetail() {
            if (this.detailLoading) {
                return false;
            }

            this.detailLoading = true;

            ApiHouseholdDetail(this.householdId)
                .then((res) => {
                    this.detailLoading = false;

                    this.info = res.data;

                    this.deviceListData = res.data.list || [];
                })
                .catch(() => {
                    this.detailLoading = false;
                });
        },
        // 查看记录
        handleToAlarm(row) {
            this.$router.push({
                path: '/alarm/index',
                // 设备编号+住户+手机号码
                query: {
                    // household_name: this.info.household_name,
                    device_imei: row.device_imei,
                    // household_phone: this.info.household_phone
                },
            });
        },

        // 解绑
        handleUnbind(row) {
            // console.log(this.info);
            const tmpType = row.device_type === 0 ? '门磁' : '迷你报警器';
            const tmpMsg = '确定要解除住户 ' + this.info.household_name + this.info.household_phone + ' 与 ' + tmpType + row.device_imei + ' 的绑定状态吗？解绑后报警记录将被清空。';

            this.$confirm(
                '<div class="custom-message-title">解绑确认</div><div class="custom-message-content">' + tmpMsg + '</div>',
                {
                    customClass: 'custom-message',
                    dangerouslyUseHTMLString: true,
                    // showClose: false,
                    type: 'warning',
                },
            )
                .then(() => {
                    ApiHouseholdUnbind({
                        household_id: this.householdId,
                        gm_id: row.gm_id,
                    })
                        .then(() => {
                            this.$message({
                                type: 'success',
                                message: '解绑成功!',
                            });

                            this.handleGetDetail();
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },

        // 删除住户
        handleRemove() {
            let tmpTitle = '删除确认';
            let tmpMsg = '确定要删除住户'
                + this.info.household_name
                + this.info.household_phone
                + '吗？';

            // 已绑定
            if (this.deviceListData.length) {
                tmpTitle = '已绑定';
                tmpMsg = '该用户已绑定设备，删除操作前须解绑设备。';

                this.$confirm(
                    '<div class="custom-message-title">'
                        + tmpTitle
                        + '</div><div class="custom-message-content">'
                        + tmpMsg
                        + '</div>',
                    {
                        customClass: 'custom-message',
                        dangerouslyUseHTMLString: true,
                        // showClose: false,
                        showCancelButton: false,
                        type: 'warning',
                    },
                )
                    .then(() => {})
                    .catch(() => {});

                return false;
            }

            this.$confirm(
                '<div class="custom-message-title">'
                    + tmpTitle
                    + '</div><div class="custom-message-content">'
                    + tmpMsg
                    + '</div>',
                {
                    customClass: 'custom-message',
                    dangerouslyUseHTMLString: true,
                    // showClose: false,
                    type: 'warning',
                },
            )
                .then(() => {
                    ApiHouseholdDelete(this.householdId)
                        .then(() => {
                            this.$message({
                                type: 'success',
                                message: '删除成功!',
                            });

                            this.$router.go(-1);
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
@import './detail.scss';
</style>
